import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconVerified.module.css';

const IconVerified = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.454 3.539 3.903 6.09a.364.364 0 0 1-.515 0L2.294 4.997a.365.365 0 1 1 .515-.516l.836.836L5.94 3.023a.365.365 0 1 1 .514.516M8.7 5.212l-.43-.838.429-.838a.46.46 0 0 0-.16-.598l-.79-.51L7.7 1.49a.457.457 0 0 0-.438-.44l-.94-.048-.513-.793a.464.464 0 0 0-.598-.158L4.374.48 3.536.05a.46.46 0 0 0-.598.16l-.51.792-.94.047a.456.456 0 0 0-.438.437l-.048.94-.793.513a.46.46 0 0 0-.158.597l.429.838-.429.839a.46.46 0 0 0 .16.597l.79.51.048.938c.01.24.2.43.438.44l.94.048.513.793a.464.464 0 0 0 .598.158l.836-.429.839.43a.46.46 0 0 0 .598-.16l.51-.792.938-.047a.457.457 0 0 0 .44-.438l.048-.94.793-.513a.46.46 0 0 0 .159-.597"
      />
    </svg>
  );
};

IconVerified.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconVerified.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconVerified;
